<div class="airdrop" [ngClass]="httpService.theme">
    <div class="d-flex justify-content-between align-items-center mb-3">
        <div class="font_lg bold d-flex gap-2">
            <span>
                {{ task.title }}</span>
            <span style="color: #cf0; font-weight: 100;">+{{ task.moons | number:'0.0-0' }}</span>
            <span> Moons</span>
            <span *ngIf="task.icon">
                <img width="20" [src]="task.icon" alt="" />
            </span>
        </div>

        <div class="referral-count">
            <span>{{ referred_user_count }}</span>
            <i class="fa-solid fa-user"></i>
        </div>
    </div>
    <div class="desc_color">
        {{ task.desc }}
    </div>

    <div>
        <cf-input [theme]="httpService.theme" [label]="'Invite Link'" [value]="invitation_link" [copy]="true"
            type="text" [readonly]="true"></cf-input>
    </div>
</div>